module.exports = __webpack_public_path__ + "img/404.a1371f83.png";